export default __webpack_public_path__ + "static/media/FD4.85217695.pdf";